import { useTranslation } from 'react-i18next';
import propTypes from 'prop-types';
import * as S from './styles';

const IMAGES_FOLDER =
  'packages/account/webapp/src/assets/images/personalized-invite/';
const SETTINGS_FILE =
  'packages/account/webapp/src/pages/Invite/PersonalizedInvite/settings.js';
const FEATURE_FLAG_FILE =
  'packages/account/webapp/src/services/feature-flag/index.js';

const PublishChecklist = ({
  personContextId,
  logoFileName,
  bannerFileName,
}) => {
  const [t] = useTranslation('personalized-invite');

  return (
    <S.Wrapper>
      <S.Title>{t('generator.checklist.title')}</S.Title>
      <S.Shortcut>{t('generator.checklist.claude-shortcut')}</S.Shortcut>
      <S.Steps>
        <li>
          {t('generator.checklist.save-images', {
            logoFileName,
            bannerFileName,
            folder: IMAGES_FOLDER,
          })}
        </li>
        <li>
          {t('generator.checklist.paste-settings', { file: SETTINGS_FILE })}
        </li>
        <li>{t('generator.checklist.map-entry')}</li>
        <li>
          {t('generator.checklist.feature-flag', {
            personContextId,
            file: FEATURE_FLAG_FILE,
          })}
        </li>
      </S.Steps>
    </S.Wrapper>
  );
};

PublishChecklist.propTypes = {
  personContextId: propTypes.string.isRequired,
  logoFileName: propTypes.string.isRequired,
  bannerFileName: propTypes.string.isRequired,
};

export default PublishChecklist;
